'use client'

import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { getHeadingTag, getHeadingVisualClassName } from '@/utilities/headingStyle'

export type BlockHeadingProps = {
  id?: string
  headingStyle?: null | string
  className?: string
  children: ReactNode
}

/**
 * Renders a section heading with configurable semantic level vs display typography.
 */
export function BlockHeading({ id, headingStyle, className, children }: BlockHeadingProps) {
  const Tag = getHeadingTag(headingStyle)
  const visual = getHeadingVisualClassName(headingStyle)

  return (
    <Tag id={id} className={cn(visual, className)}>
      {children}
    </Tag>
  )
}
